
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IRiderRepository } from "./IRider";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Rider } from "src/app/models/Restaurant/Rider/rider-model";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { environment } from "src/environments/environment";

@Injectable({providedIn:'root'})
export class RiderRepository extends GenericRepository<Rider> implements IRiderRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {

        super(_http, 'api/rider/', environment.urlAddress);
    }
    GetRiderAddress(salesAgentCode: string, addressType: string) {
        return this._http.get(this.url + 'api/rider/RiderAddress' + '/' + salesAgentCode + '/' + addressType, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetNavRec(navType: number, currentIndex: number): Observable<any> {
        return this._http.get(this.url + 'api/rider/NavRec' + '/' + navType + '/' + currentIndex, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    LoadRec(salesAgentCode: string, isAddress: boolean, isName: boolean): Observable<any> {
    return this._http.get(this.url + 'api/rider/GetRec/' + salesAgentCode + '/' + isAddress + '/' + isName, this.httpOptions)
        .pipe(map(this.extractData), catchError(this.handleError));
}
      DeleteRec(salesAgentCode: string) {
        return this._http.delete(
            this.url + 'api/rider/DeleteRec/' + salesAgentCode,
            this.httpOptions
        ).pipe(map(this.extractData), catchError(this.handleError));
    }
    SelectAll(isActive: boolean): Observable<any> {
        return this._http.get(this.url + 'api/rider/SelectAll' + '/' + isActive, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }     
    
    GetAll(currentPage: number, pageSize: number, searchText: string): Observable<any> {
    return this._http.get(
        this.url + 'api/rider/GetAll?currentPage=' + currentPage +
        '&pageSize=' + pageSize +
        '&searchText=' + (searchText ? encodeURIComponent(searchText) : ''),
        this.httpOptions
    ).pipe(map(this.extractData), catchError(this.handleError));
}
}
